import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import type { ModuleRouter, PageRouter } from '@tools/ui/types';
import useRouter from '@tools/ui-hooks/useRouter.hook';
import Loading from '../Loading';
import TrackedRoute from './TrackedRoute';

type TProps = {
  router: PageRouter | ModuleRouter;
};

const InnerRouter: React.FC<React.PropsWithChildren<TProps>> = ({ router }) => {
  const { match } = useRouter();
  const routes = (router as ModuleRouter).pages || (router as PageRouter).tabs;

  return (
    <React.Suspense fallback={<Loading />}>
      <Switch>
        {routes.map(
          ({ name, path, tabs, component: Component, ...routeProps }) => (
            <TrackedRoute
              key={name}
              path={[match.path, path].join('')}
              {...routeProps}
            >
              <Component router={{ tabs } as PageRouter} />
            </TrackedRoute>
          )
        )}
        {!!routes[0]?.path && (
          <TrackedRoute exact path={match.path}>
            <Redirect to={`${match.url}${routes[0].path}`} />
          </TrackedRoute>
        )}
      </Switch>
    </React.Suspense>
  );
};

export default React.memo(InnerRouter);
